export default __webpack_public_path__ + "static/media/001-twitter.7e68159c.svg";